// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Tooltip as HeroTooltip } from "@heroui/react";
import { clsx } from "clsx";
import type { ComponentProps, ReactElement, ReactNode } from "react";

export interface TooltipProps {
  children: ReactElement;
  content: ReactNode;
  placement?: ComponentProps<typeof HeroTooltip.Content>["placement"];
  delay?: number;
  closeDelay?: number;
  showArrow?: boolean;
  className?: string;
}

export function Tooltip({
  children,
  content,
  placement = "top",
  delay = 350,
  closeDelay = 100,
  showArrow = true,
  className,
}: TooltipProps) {
  return (
    <HeroTooltip.Root delay={delay} closeDelay={closeDelay}>
      <HeroTooltip.Trigger className="contents">
        {children}
      </HeroTooltip.Trigger>
      <HeroTooltip.Content
        placement={placement}
        showArrow={showArrow}
        className={clsx("tapp-tooltip", className)}
      >
        {content}
      </HeroTooltip.Content>
    </HeroTooltip.Root>
  );
}
